import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, UpsertJobUserSnapshotRequest } from "@/types";

export function useUpsertJobUserSnapshot() {
  return useMutation({
    mutationFn: async (request: UpsertJobUserSnapshotRequest) => {
      await guacHttpClient.post<
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        void,
        HttpResponse<void>,
        UpsertJobUserSnapshotRequest
      >("job-users/snapshots", request);
    },
  });
}
